import React from 'react';
import { Image, List } from '@landing/ui';

import * as styles from './ProgramItems.module.scss';

export default function ProgramItems({ items }) {
  return (
    <>
      {items.map(({ time, description, secondDescription, list, speakers }) => (
        <div key={time} className={styles.item}>
          <div className={styles.time}>{time}</div>
          <div className={styles.aboutItem}>
            <p>{description}</p>
            {secondDescription && <p>{secondDescription}</p>}
            {list && <List className={styles.list} items={list} />}
            {speakers && (
              <div className={styles.speakers}>
                {speakers.map(({ photo, name, company }) => (
                  <figure className={styles.speaker} key={name}>
                    <Image
                      src={photo}
                      alt={name}
                      className={styles.speakerPicture}
                      classImage={styles.speakerImg}
                    />
                    <figcaption>
                      <p className={styles.speakerName}>{name}</p>
                      {company && <p className={styles.speakerCompany}>{company}</p>}
                    </figcaption>
                  </figure>
                ))}
              </div>
            )}
          </div>
        </div>
      ))}
    </>
  );
}
